import timedFetch from 'middleware/timedFetch';
import { cookieObjectToString } from 'helpers/Cookie';
import { generateIncludes } from 'apis/calypso';
import { addClientHeaders } from 'apis/mafia';

/**
 * Perform a typed term search
 * @param  {object}   diamond         diamond info
 * @param  {object}   calypso          calypso info
 * @param  {object}   request        request criteria
 * @param {object} appState           redux store state
 * @param  {function} [fetcher=fetch] fetch or fetch like implementation
 * @return {object}                   promise
 */
export function termSearch({ url }, { term, proxy = true }, request = {}, appState, fetcher = timedFetch('diamondTermSearch')) {
  const includes = generateIncludes(appState);
  const reqUrl = `${url}/esb/siteSearch/?term=${term}&includes=${includes}${proxy ? '&proxy=true' : ''}`;
  const mafiaHeaders = addClientHeaders(request);
  // for calypso personalized search
  const cookieHeader = { Cookie: cookieObjectToString(appState.cookies) };
  const headers = { ... mafiaHeaders, ...cookieHeader };

  return fetcher(reqUrl, {
    headers,
    credentials: 'include' // only good for clientside
  });
}
